<template>
  <div class="time_wrapper">
    <div>{{d ? d : 0}}</div>天
    <div>{{h ? h : 0}}</div>时
    <div>{{m ? m : 0}}</div>分
    <div>{{s ? s : 0}}</div>秒
  </div>
</template>

<script>
  // import dayjs from 'dayjs'

  export default {

    props: {
      index: {
        defalut: ''
      },
      enddate: {
        default: ''
      }
    },
    data () {
      return {
        d: '',
        h: '',
        m: '',
        s: '',
      }
    },
    created () {
      this.countTime()
      // this.start()
    },
    watch: {
      enddate () {
        this.countTime()
      }
    },
    methods: {
      countTime: function() {
        // //获取当前时间
        var date = new Date()
        var now = date.getTime()
        // //设置截止时间
        var endDate = this.enddate ? new Date(this.enddate) : date
        var end = endDate.getTime()
        // //时间差
        var leftTime = end - now
        //定义变量 d,h,m,s保存倒计时的时间
        if (leftTime >= 0) {
          this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)//天数我没用到，暂且写上
          if (this.d > 0) {
            // this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24) + Number(this.d * 24)
            this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
          } else {
            this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
          }
          this.m = Math.floor((leftTime / 1000 / 60) % 60)
          this.s = Math.floor((leftTime / 1000) % 60)
          //递归每秒调用countTime方法，显示动态时间效果
          setTimeout(this.countTime, 1000)
        }
        // console.log(this.time, this.h, this.m, this.s)

        this.$emit('change', leftTime, this.index)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/variables.scss';
  .time_wrapper {
    display: flex;
    align-items: center;
    div {
      font-size: $fontsize-medium;
      width: 20px;
      height: 20px;
      border-radius: 2px;
      color: #fff;
      background-color: #E91D1D;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 1px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
</style>
